type FilterData = {
  filterType: string;
  value: string | number;
};

export const parseFilterString = (value: string): FilterData[] => {
  const filterStrings = value.split(' ');
  const filters: FilterData[] = [];

  for (const filterString of filterStrings) {
    const match = filterString.match(/^([a-zA-Z0-9-]+)\(([^)]*)\)$/);

    if (match) {
      const filterType = match[1];
      const rawValue = match[2];
      const parsedValue = isNaN(Number(rawValue)) ? rawValue : Number(rawValue);
      filters.push({ filterType, value: parsedValue });
    }
  }

  return filters;
};
